import { FixedPxBox } from "@novel/shared/components/Box";
import React, { useCallback, useState } from "react";
import cx from "classnames";
import { TorusWalletComponent } from "@novel/shared/components/ConnectWalletComponent/wallets/TorusWalletComponent";
import { MetamaskWalletComponent } from "@novel/shared/components/ConnectWalletComponent/wallets/MetamaskWalletComponent";
import { CoinbaseWalletComponent } from "@novel/shared/components/ConnectWalletComponent/wallets/CoinbaseWalletComponent";
import { WalletConnectComponent } from "@novel/shared/components/ConnectWalletComponent/wallets/WalletConnectComponent";
import { PhantomWalletComponent } from "@novel/shared/components/ConnectWalletComponent/wallets/PhantomWalletComponent";
import { IConnectWalletProps } from "@novel/shared/components/ConnectWalletComponent/types";
import { AuthWallet } from "@novel/shared/utils/wallets/AuthWallet";
import { WalletConnectV2Component } from "@novel/shared/components/ConnectWalletComponent/wallets/WalletConnectV2Component";
type TabId = "createWallet" | "connectWallet";
const tabs: {
  id: TabId;
  content: string;
}[] = [{
  id: "createWallet",
  content: `Create A Wallet`
}, {
  id: "connectWallet",
  content: "Connect Existing Wallet"
}];
interface IConnectWalletTabbedComponentProps extends IConnectWalletProps {
  readonly initialTabId?: TabId;
  readonly superUser?: boolean;
}
export function ConnectOrCreateWalletTabbedComponent({
  blockchainTypes,
  onConnectWallet,
  initialTabId = "connectWallet",
  superUser,
  AuthWalletClass = AuthWallet
}: IConnectWalletTabbedComponentProps): JSX.Element {
  const [selectedTab, setSelectedTab] = useState<TabId>(initialTabId);
  const handleTabChange = useCallback((selectedTabIndex: TabId) => setSelectedTab(selectedTabIndex), []);
  return <React.Fragment>
            <FixedPxBox alignItems="center" column>
                <FixedPxBox columnGap={4}>
                    {tabs.map(tab => <TabButton key={tab.id} isSelected={selectedTab === tab.id} handleTabChange={handleTabChange} tabId={tab.id} content={tab.content} />)}
                </FixedPxBox>

                {selectedTab === "createWallet" && <FixedPxBox alignItems="center" column mt={2.5} width="100%">
                        <div className="Box-Connect">
                            <TorusWalletComponent onConnectWallet={onConnectWallet} AuthWalletClass={AuthWalletClass} />
                            <div className="connect-wallet-explanation-text connect-wallet-highly-recommend-text">
                                We <span className="tooltip">highly recommend</span> clicking the
                                above to create a Torus wallet if you do not already have a wallet.
                            </div>
                        </div>
                        <div className="connect-wallet-modal-spacer" />
                        <div className="connect-wallet-two-in-a-box">
                            <div className="Box-Connect-small">
                                <MetamaskWalletComponent onConnectWallet={onConnectWallet} AuthWalletClass={AuthWalletClass} />
                            </div>
                            <div className="connect-wallet-side-spacer" />
                            <div className="Box-Connect-small">
                                <CoinbaseWalletComponent onConnectWallet={onConnectWallet} AuthWalletClass={AuthWalletClass} />
                            </div>
                        </div>
                    </FixedPxBox>}
                {selectedTab === "connectWallet" && <FixedPxBox alignItems="center" column mt={2.5} width="100%">
                        <div className="Box-Connect">
                            <TorusWalletComponent onConnectWallet={onConnectWallet} AuthWalletClass={AuthWalletClass} />
                        </div>
                        <div className="connect-wallet-modal-spacer" />
                        <div className="connect-wallet-two-in-a-box">
                            <div className="Box-Connect-small">
                                <MetamaskWalletComponent onConnectWallet={onConnectWallet} AuthWalletClass={AuthWalletClass} />
                            </div>
                            <div className="connect-wallet-side-spacer" />
                            <div className="Box-Connect-small">
                                <CoinbaseWalletComponent onConnectWallet={onConnectWallet} AuthWalletClass={AuthWalletClass} />
                            </div>
                        </div>
                        <div className="connect-wallet-modal-spacer" />
                        <div className="connect-wallet-two-in-a-box">
                            <div className="Box-Connect-small">
                                <WalletConnectComponent onConnectWallet={onConnectWallet} AuthWalletClass={AuthWalletClass} />
                            </div>
                            <div className="connect-wallet-side-spacer" />
                            <div className="Box-Connect-small">
                                <PhantomWalletComponent onConnectWallet={onConnectWallet} AuthWalletClass={AuthWalletClass} disabled={!blockchainTypes.includes("solana") ? "must connect an evm wallet to claim" : ""} />
                            </div>
                        </div>
                        {superUser && <React.Fragment>
                                <div className="connect-wallet-modal-spacer" />
                                <div className="connect-wallet-two-in-a-box">
                                    <div className="Box-Connect-small">
                                        <WalletConnectV2Component onConnectWallet={onConnectWallet} AuthWalletClass={AuthWalletClass} />
                                    </div>
                                    {/* <div className="connect-wallet-side-spacer" /> */}
                                </div>
                            </React.Fragment>}
                    </FixedPxBox>}
            </FixedPxBox>
            <style>{`
                #torusIframe, #torusAlertContainer {
                    z-index: 9999999 !important;
                }
            `}</style>
        </React.Fragment>;
}
function TabButton({
  tabId,
  isSelected,
  content,
  handleTabChange
}: {
  readonly tabId: TabId;
  readonly isSelected: boolean;
  readonly content: string;
  readonly handleTabChange: (tabId: TabId) => void;
}) {
  const onClick = useCallback(() => handleTabChange(tabId), [handleTabChange, tabId]);
  return <button key={tabId} className={cx("connect-wallet-tab", {
    "selected-connect-wallet-tab": isSelected
  })} onClick={onClick}>
            {content}
        </button>;
}